// FeedsPopup styled components for various popup UIs in the application.
// Provides wrappers, titles, buttons, images, and text styles for popups such as Feed, Anniversary, Video, Birthday, etc.
// All components use styled-components and are responsive for different screen sizes.

import styled from "styled-components";
import playIcon from "../../../images/play-Icon.svg";
import ribbonLeft from "../../../images/ribbon-left.svg";
import ribbonRight from "../../../images/ribbon-right.svg";

// Main wrapper for feed popups
export const FeedPopupWrapper = styled.div`
  width: 100%;
  height: auto;
  overflow-y: ${({ connect, YUPCarousel }) =>
    connect ? "clip" : YUPCarousel ? "Visible" : "auto"};
  overflow-x: ${({ YUPCarousel }) => (YUPCarousel ? "visible" : "hidden")};
  padding: ${({ connect }) => (connect ? "0% 1% 0" : "3% 5% 0")};
  display: flex;
  flex-direction: ${({ connect }) => (connect ? "row" : "column")};
  margin: 1% 0.5%;
  margin-bottom: 2rem;
  position: relative;
  & img {
    border-radius: 10px;
  }

  @media screen and (max-width: 850px) {
    overflow: hidden auto;
    width: 100%;
    height: auto;
    margin-bottom: 1rem;
    ${(props) =>
      props.responsePopup &&
      `
           height: 100%;
           top:5%;
       `}
    flex-direction:${({ connect }) => (connect ? "column" : "column")};
  }
`;

// Wrapper for carousel feed popups, extends FeedPopupWrapper
export const CarouselFeedPopupWrapper = styled(FeedPopupWrapper)`
  padding: 1px;
  margin: 0px;
`;

// Wrapper for anniversary popups
export const AnniversaryPopupWrapper = styled.div`
    width:100%;
    height: auto;
    overflow-y:${({ connect }) => (connect ? "clip" : "auto")};
    overflow-x:${({ connect }) => (connect ? "clip" : "auto")}
    padding: ${(props) => (props.popup != "img1" ? "3% 1% 3% 1%" : "0px")};
    display:flex;
    flex-direction:${({ connect }) => (connect ? "row" : "column")};
    margin:${({ props }) => (props?.isAnniversary ? "0" : "1%")}

    @media screen and (max-width: 850px){
        overflow: hidden auto;
        width: 100%;
        height: auto;
        ${(props) =>
          props.responsePopup &&
          `
            height: 100%;
        `}
        flex-direction:${({ connect }) => (connect ? "column" : "column")};
    }
`;

// Wrapper for image popups
export const ImagePopupWrapper = styled.div`
    padding: 2% 3%;
    max-height: 80vh;
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow-y: auto;
    margin:0.5%;
}
`;

// Title style for popups
export const PopupTitle = styled.div`
  position: relative;
  width: 100%;
  padding: 0 0 3% 0px;
  text-align: left;
  font-family: "Lato";
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 120%;
  color: rgba(0, 0, 0, 1);
  overflow: clip;
  margin-bottom: 2%;
  white-space: ${({ pdf }) => (pdf ? "nowrap" : "")};
  text-overflow: ellipsis;
  margin: 0 auto;
  @media screen and (max-width: 850px) {
    width: 100%;
    margin: 0px auto;
    font-size: 24px;
    font-weight: 600;
    line-height: 30px;
  }
`;

// Title style for anniversary popups
export const AnniversaryPopupTitle = styled.div`
  position: relative;
  width: 100%;
  padding: 1% 15%;
  text-align: center;
  font-family: "Lato";
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 120%;
  color: #fff;
  overflow: clip;
  margin-bottom: 2%;
  white-space: ${({ pdf }) => (pdf ? "nowrap" : "")};
  text-overflow: ellipsis;
  margin: 0 auto;
  background-color: #00acca;
  border-radius: 10px 10px 0 0;
  box-shadow: 2px 3px 3px #00000030;
  ::before {
    position: absolute;
    content: "";
    width: 20%;
    height: 99%;
    left: -10px;
    top: -5px;
    background-image: url(${ribbonLeft});
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    @media screen and (min-width: 1600px) and (max-width: 1920px) {
      width: 15%;
    }
    @media screen and (max-width: 750px) {
      width: 22%;
      height: 99%;
      left: -3px;
      top: -18px;
    }
  }
  ::after {
    position: absolute;
    content: "";
    width: 20%;
    height: 99%;
    right: -10px;
    top: -5px;
    background-image: url(${ribbonRight});
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    @media screen and (min-width: 1600px) and (max-width: 1920px) {
      width: 15%;
    }
    @media screen and (max-width: 750px) {
      width: 20%;
      height: 100%;
      right: -5px;
      top: -15px;
    }
  }
  & p {
    margin-bottom: 5px !important;
    margin-top: 10px;
  }
  @media screen and (max-width: 750px) {
    width: 100%;
    margin: 0 auto;
    font-size: 15px;
    padding: 5% 15%;
  }
`;

// Title style for connect popups
export const ConnectPopupTitle = styled.span`
  color: #111;
  font-family: Lato;
  font-size: 18px;
  font-weight: 700;
  font-style: normal;
  line-height: 120%;
  margin-bottom: 2%;
  ${(props) =>
    props?.progress &&
    `
      top: -5%;
   `}
  @media screen and (max-width: 414px) {
    width: 82%;
    ${(props) =>
      props.progress &&
      `
           top: -2%;
       `}
  }
  @media screen and (width: 375px) {
    ${(props) =>
      props.progress &&
      `
           font-size: 16px;
      `}
  }
  @media screen and (min-width: 415px) and (max-width: 850px) {
    ${(props) =>
      props.progress &&
      `
           top: -2%;
           margin-left: 6%;
       `}
  }
`;

// Text style for tracking information
export const TrackText = styled.div`
  position: relative;
  width: 100%;
  height: 5vh;
  top: 2vh;
  color: #474747;
  text-align: center;
  font-family: Lato;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 135%;
  letter-spacing: 0.15px;
  z-index: 1;
  margin-left: 19px;
  :before,
  :after {
    position: absolute;
    top: 32%;
    overflow: hidden;
    width: 15%;
    height: 1.5px;
    content: "\a0";
    background-color: #f66700;
  }
  :before {
    margin-left: -17%;
    text-align: right;
  }
`;

// Wrapper for tracked images in tracking UI
export const TrackedImg = styled.div`
  position: absolute;
  & img {
    position: absolute;
    top: -2.5vh;
    left: -8px;
    width: 18px;
    heigth: 18px;
    display: flex;
    background-size: cover;
  }
  & {
    display: block;
    position: absolute;
    background-color: #f66700;
    width: 2px;
    top: 18px;
    left: -2.75vh;
    height: 9.75vh;
    transform: translateX(-50%);
  }
  & div {
    display: block;
    position: absolute;
    background-color: #f66700;
    width: 2px;
    top: -32px;
    left: 1px;
    height: 18px;
    transform: translateX(-50%);
  }
`;

// Wrapper for not tracked images in tracking UI
export const NotTrackedImg = styled.div`
  position: absolute;
  & img {
    position: absolute;
    top: -2.5vh;
    left: -8px;
    width: 18px;
    heigth: 18px;
    display: flex;
    background-size: cover;
  }
  & {
    display: block;
    position: absolute;
    background-color: #999999;
    width: 2px;
    top: 18px;
    left: -2.75vh;
    height: 9.75vh;
    transform: translateX(-50%);
  }
`;

// Wrapper for last tracked images in tracking UI
export const LastTrackedImg = styled.div`
  position: absolute;
  & img {
    position: absolute;
    top: -2.5vh;
    left: -9px;
    width: 18px;
    heigth: 18px;
    display: flex;
    background-size: cover;
  }
  & {
    display: block;
    position: absolute;
    top: 18px;
    left: -2.75vh;
  }
`;

// Wrapper for PDF popup images
export const PDFPopupImage = styled.div`
  min-height: ${(props) => (props.pdf ? "unset" : "60%")};
  align-items: center;
  justify-content: center;
  display: flex;
  margin-bottom: ${(props) => (props.pdf ? "-5px" : "0px")};
  margin-top: 5px;
  background: rgba(0, 0, 0, 0.05);
  @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) {
    margin-top: 2px;
  }
  & .fallback-div-image {
    align-items: center;
    justify-content: center;
    display: flex;
    background: transparent;
    text-align: center;
    flex-flow: column;
    gap: 5px;
  }
  & .fallback-div-image img {
    position: unset;
  }
  & img {
    max-width: ${(props) => (!props.pdf ? "90%" : "")};
    max-height: ${(props) => (!props.pdf ? "41vh" : "")};
    width: auto;
    height: 100%;
    @media screen and (max-width: 600px) {
      max-width: 100%;
    }
    @media screen and (min-width: 600px) and (max-width: 850px) {
      width: 100%;
      max-height: 100%;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) {
      max-width: 100%;
      width: auto;
      max-height: 100%;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: landscape) {
      max-height: 100%;
    }
  }
  & div {
    position: ${(props) => (props.pdf ? "absolute" : "relative")};
    top: ${(props) =>
      props.mediaAccess ? "22vh" : props.pdf ? "100%" : "auto"};
    bottom: -2px;
    width: 100%;
    height: ${(props) => (props.mediaAccess ? "7.5vh" : "4vh")};
    border-radius: 0px 0px 5px 5px;
    opacity: 0.699999988079071;
    background: #000;
    display: flex;
    justify-content: right;
    margin-top: 0px;
    @media screen and (min-width: 300px) and (max-width: 749px) {
      top: ${(props) => (props.pdf ? "100%" : "")};
      padding-top: 6px;
      margin-top: 0px;
    }
    @media screen and (min-width: 1200px) and (max-width: 1400px) {
       {
        bottom: 0px;
        height: ${(props) => (props.mediaAccess ? "7.5vh" : "6vh")};
      }
    }
    @media screen and (min-width: 1400px) and (max-width: 1600px) {
       {
        bottom: 0px;
        height: ${(props) => (props.mediaAccess ? "7.5vh" : "5vh")};
      }
    }
    @media only screen and (min-width: 750px) and (max-width: 820px) {
      padding-top: 4px;
    }
    @media only screen and (min-width: 821px) and (max-width: 1199px) and (orientation: portrait) {
      padding-top: 7px;
    }
  }
  @media screen and (max-width: 600px) {
    width: ${(props) => (props.pdf ? "98%" : "100%")};
  }
  @media screen and (min-width: 600px) and (max-width: 740px) {
    width: 100%;
  }
  @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) {
    width: 100%;
  }
`;

// Date stamp style for popups
export const PopupDate = styled.div`
  padding: 5px 0;
  color: #f66700;
  font-weight: bold;
  font-size: 18px;
`;

// Image style for popups
export const PopupImage = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  margin-bottom: ${(props) => (props.pdf ? "0" : "32px")};
  margin-top: 5px;
  background: rgba(0, 0, 0, 0.05);
  @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) {
    margin-top: 2px;
  }
  // Code for error handling
  & .fallback-div-image {
    display: block;
    top: 10px;
    background: transparent;
    text-align: center;
  }
  & .fallback-div-image img {
    position: unset;
  }
  & img {
    border-radius: 10px;
    max-width: ${(props) => (!props.pdf ? "90%" : "")};
    max-height: ${(props) => (!props.pdf ? "41vh" : "")};
    width: auto;
    height: 100%;
    @media screen and (max-width: 600px) {
      max-width: 100%;
    }
    @media screen and (min-width: 600px) and (max-width: 850px) {
      width: 100%;
      max-height: 100%;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) {
      max-width: 100%;
      width: auto;
      max-height: 100%;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: landscape) {
      max-height: 100%;
    }
  }
  & div {
    position: absolute;
    top: ${(props) =>
      props.mediaAccess ? "22vh" : props.pdf ? "100%" : "auto"};
    bottom: -2px;
    width: 100%;
    height: ${(props) => (props.mediaAccess ? "7.5vh" : "4vh")};
    border-radius: 0px 0px 5px 5px;
    opacity: 0.699999988079071;
    background: #000;
    display: flex;
    justify-content: right;
    margin-top: 0px;
    @media screen and (min-width: 300px) and (max-width: 749px) {
      top: ${(props) => (props.pdf ? "100%" : "")};
      padding-top: 6px;
      margin-top: 0px;
    }
    @media screen and (min-width: 1200px) and (max-width: 1400px) {
       {
        bottom: 0px;
        height: ${(props) => (props.mediaAccess ? "7.5vh" : "6vh")};
      }
    }
    @media screen and (min-width: 1400px) and (max-width: 1600px) {
       {
        bottom: 0px;
        height: ${(props) => (props.mediaAccess ? "7.5vh" : "5vh")};
      }
    }
    @media only screen and (min-width: 750px) and (max-width: 820px) {
      padding-top: 4px;
    }
    @media only screen and (min-width: 821px) and (max-width: 1199px) and (orientation: portrait) {
      padding-top: 7px;
    }
  }
  @media screen and (max-width: 600px) {
    width: ${(props) => (props.pdf ? "98%" : "100%")};
  }
  @media screen and (min-width: 600px) and (max-width: 740px) {
    width: 100%;
  }
  @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) {
    width: 100%;
  }
`;

// DateTime stamp style for PDF popups
export const PDFDateTimeStamp = styled.div`
  position: relative;
  width: 100%;
  height: ${(props) => (props.mediaAccess ? "7.5vh" : "5vh")};
  border-radius: 0px 0px 5px 5px;
  opacity: 0.699999988079071;
  background: #000;
  display: flex;
  justify-content: right;
  margin-top: 0px;
  @media screen and (min-width: 1200px) and (max-width: 1400px) {
    width: ${(props) => (props.pdf ? "90%" : "100%")};
    height: ${(props) => (props.mediaAccess ? "7.5vh" : "6vh")};
  }
  @media screen and (max-width: 750px) {
    width: 98%;
    padding-top: 13px;
    height: ${(props) => (props.mediaAccess ? "7.5vh" : "5vh")};
  }
  @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) {
    width: 100%;
    padding-top: 8px;
    height: ${(props) => (props.mediaAccess ? "7.5vh" : "6vh")};
  }
`;

// iFrame style for PDF popups
export const PDFiframe = styled.iframe`
    width: 100% ;
    height: 55vh;
    background: #FFFFFF;
    allowtransparency="true";
    #outerContainer #mainContainer div.toolbar {
        display: none !important;
      }
    #outerContainer #mainContainer #viewerContainer {
        top: 0 !important;
      }
    
    @media screen and (max-width: 420px){
        width: 100%;
        height: 50vh;
     }
     @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) 
     and (orientation: portrait){
        height: 45vh;
     }
`;

// Wrapper for connect popup images
export const ConnectPopupImage = styled.div`
  position: relative;
  top: 2%;
  width: 100%;
  height: 70%;
  align-items: center;
  justify-content: center;
  display: flex;
  background: rgba(0, 0, 0, 0.05);
  margin-bottom: 2%;
  @media screen and (max-width: 412px) {
    ${(props) =>
      props.responsePopup &&
      `
            height: 65%;
        `}
  }
  @media screen and (max-width: 850px) {
    ${(props) =>
      props.responsePopup &&
      `
            width: 100%;
            height: 55%;
        `}
  }
  & img {
    width: 24vw;
    height: 58vh;
    position: absolute;
    top: 1px;
    border: 2px solid #ffffff;
    filter: drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.2));
    border-radius: 5px;
    @media screen and (max-width: 850px) {
      ${(props) =>
        props.responsePopup &&
        `
                width: 100%;
            `}
    }
  }
`;

// Wrapper for connect progress images
export const ConnectProgressImageWrapper = styled.div`
  position: relative;
  left: 2vw;
  width: 46vh;
  height: 65vh;
  align-items: center;
  justify-content: center;
  display: flex;
  background-image: url(${(props) => props.image});
  background-size: cover;
  background-position: center;
  @media screen and (max-width: 600px) {
    width: 100%;
    padding: 10px;
    left: 0;
  }
  @media screen and (min-width: 601px) and (max-width: 850px) {
    width: 90%;
    left: 0;
    height: auto;
    margin: 0 auto;
  }
  @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) {
    height: 65vh;
  }
`;

// Wrapper for message content in popups
export const MessageWrapper = styled.div`
  position: relative;
  width: 32vh;
  height: 44vh;
  overflow-y: auto;
  @media screen and (max-width: 600px) {
    width: 70%;
    top: 0%;
    height: 70%;
  }
  ::-webkit-scrollbar {
    width: 3.5px;
    border-radius: 9px;
  }
  ::-webkit-scrollbar-track {
    background-color: #fff;
    width: 5px;
    border-radius: 9px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 9px;
    width: 5px;
  }
   {
    -ms-overflow-style: none;
    scrollbar-width: thin;
  }
  & pre {
    white-space: pre-wrap;
    white-space: -moz-pre-wrap;
    white-space: -pre-wrap;
    white-space: -o-pre-wrap;
    word-wrap: break-word;
  }
  & p {
    width: 95%;
    height: auto;
    justify-content: center;
    color: #000;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%;
    word-wrap: break-word;
    @media screen and (max-width: 820px) {
      font-size: 20px;
    }
  }
  & img {
    max-width: 19vh;
    max-height: 15vh;
    width: auto;
    height: auto;
    position: relative;
    justify-content: center;
    align-items: center;
    left: 50%;
    transform: translate(-50%, -0%) rotate(-0.456deg);
    background-size: cover;
    border-radius: 2px;
    border: 2px solid var(--wv-white, #fff);
  }
`;

// Wrapper for tracking information in popups
export const TrackingWrapper = styled.div`
  position: relative;
  width: 80%;
  height: ${(props) => (props.height ? props.height : "55vh")};
  top: 6vh;
  left: 5vh;
  overflow: clip;
  ${(props) =>
    props.progress &&
    `
      width: 90%;
      height: auto;
      top: 4vh;
    `}
  @media screen and (max-width: 400px) {
    width: 100%;
    left: 5%;
  }
  & ul {
    padding-left: 0rem;
  }
  ::-webkit-scrollbar {
    width: 3.5px;
    border-radius: 9px;
  }

  ::-webkit-scrollbar-track {
    background-color: #fff;
    width: 5px;
    border-radius: 9px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 9px;
    width: 5px;
  }
   {
    -ms-overflow-style: none;
    scrollbar-width: thin;
  }
`;

// Individual tracking item style
export const TrackingItem = styled.div`
  position: relative;
  top: 3.6vh;
  left: 4.5vh;
  width: 85%;
  height: 10vh;
  color: #111;
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 135%;
  letter-spacing: 0.16px;
  & span {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
  }
  &:last-child::before {
    content: "";
    position: absolute;
    top: -5%;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.65);
    z-index: 0;
    border-radius: 8px;
  }
  & > * {
    z-index: 1;
  }
  @media screen and (min-width: 1200px) and (max-width: 1400px) {
    height: 12vh;
  }
  @media screen and (min-width: 1600px) and (max-width: 1920px) {
    width: 91%;
  }
`;

// Save button style for popups
export const SaveButton = styled.button`
   {
    position: relative;
    width: auto;
    background-color: transparent;
    padding: 0 10px 0 3px;
    margin-top: ${(props) => (props?.isYUP ? "2px" : "-2px")};
    margin-bottom: 1rem;
    @media screen and (max-width: 600px) {
      right: -1vw;
      margin-top: -4px;
    }
    & img {
      position: relative;
      width: 16px;
      height: 18px;
      background-color: transparent;
      border: 0;
      border-radius: 0;
      margin-right: 2px;
    }
    & span {
      position: relative;
      color: ${(props) => (props?.mediagallery ? "#000" : "#FFF")};
      font-size: 12px;
      font-family: Lato;
      font-weight: 500;
      line-height: 120%;
      @media screen and (max-width: 740px) {
        font-size: 10px;
      }
    }
    @media screen and (min-width: 600px) and (max-width: 850px) {
      top: 0px;
    }
    @media screen and (min-width: 1600px) and (max-width: 1920px) {
      margin-top: 2px;
    }
  }
`;

// Date style for content in popups
export const ContentDate = styled.p`
  position: absolute;
  width: auto;
  height: 12px;
  left: 20px;
  flex-wrap: nowrap;
  background-color: transparent;
  color: #fff;
  font-size: 16px;
  font-family: Lato;
  font-weight: 400;
  line-height: 2;
  @media screen and (max-width: 600px) {
    margin: -0.5% 0;
    font-size: 13px;
  }
  @media screen and (min-width: 1600px) and (max-width: 1920px) {
    margin-top: 2px;
  }
  @media screen and (max-width: 740px) {
    font-size: 13px;
  }
`;

// Link style for viewing PDF in popups
export const ViewPDFA = styled.a`
  position: relative;
  color: #ffffff;
  text-decoration: none;
  font-size: 12px;
  font-family: Lato;
  font-weight: 500;
  line-height: 120%;
  margin-right: 8%;
  padding-right: 3%;
  border-right: 1px solid #ffffff;
`;

// Share button style for popups
export const ShareButton = styled.button`
  position: relative;
  width: auto;
  height: 20px;
  padding: 0 10px 0 10px;
  margin-top: 2px;
  margin-bottom: 1rem;
  background-color: transparent;
  @media screen and (max-width: 600px) {
   margin-top: -4px
  }
  & img {
    position: relative;
    width: 15px;
    height: 18px;
    background-color: transparent;
    border: 0;
    border-radius: 0;
  }
  & span {
    position: relative;
    color: #fff;
    font-size: 12px;
    font-family: Lato;
    font-weight: 500;
    line-height: 120%;
    margin-left: 8px;
    @media screen and (max-width: 740px) {
      font-size: 10px;
    }
  }
  @media screen and (min-width: 600px) and (max-width: 850px) {
    top: 0px;
  }
  @media screen and (min-width: 1600px) and (max-width: 1920px) {
    margin-top: 2px;
  }
  @media screen and (min-width: 1200px) and (max-width: 1400px) {
    margin-top: 4px;
  }
  @media screen and (min-width: 1400px) and (max-width: 1600px) {
    margin-top: 4px;
  }
`;

// Text wrapper for popups
export const PopupText = styled.div`
    position: relative;
    width:100%;
    margin:0 auto;
    margin-bottom:10px;
    margin-top:10px;
    padding:10px 0px;
    & p{
        width:auto;
        color: var(--wv-black-soft, #111);
        text-align: ${({ props }) =>
          props?.isAnniversary ? "center" : "left"};
        font-size: 18px;
        font-family: Lato;
        line-height: 120%;
        letter-spacing: 0.18px;
        overflow-y: auto;
        white-space: pre-wrap;
        @media screen and (max-width: 750px){
            font-size: 16px;
        }
    }
    @media screen and (max-width: 600px){
        max-height:${({ props }) => (props?.isAnniversary ? "auto" : "10vh")}
        margin-bottom:10%;
        width: 100%;
        height: auto;
        max-width: 100%;
        margin: 0px auto 10px;
        p {
            height: auto;
        }
    }
    @media screen and (min-width: 600px) and (max-width: 850px){
        width: 100%;
        height: auto;
        margin:0 auto;
    }
    ::-webkit-scrollbar {
        width: 3.5px;
        border-radius: 9px;
    }   
    ::-webkit-scrollbar-track {
        background-color: #FFF;
        width: 5px;
        border-radius: 9px;
    }   
    ::-webkit-scrollbar-thumb {
        background-color: #C1C1C1;
        border-radius: 9px;
        width: 5px;
    }  
    {
      -ms-overflow-style: none;
      scrollbar-width: thin;
    }
`;

// Text wrapper for anniversary popups
export const AnniversaryPopupText = styled.div`
    position: relative;
    width:90%;
    margin:${(props) => (props.nodata ? "20% auto" : "0 auto")};
    margin-bottom:10px;
    padding:10px 0px;
    & p{
    width:auto;
    color: var(--wv-black-soft, #111);
    text-align: center;
    font-size: 18px;
    font-family: Lato;
    line-height: 120%;
    letter-spacing: 0.18px;
    overflow-y: auto;
    white-space: pre-wrap;
    margin-bottom:0px;
    @media screen and (max-width: 750px){
        font-size: 16px;
    }
}
@media screen and (max-width: 600px){
    max-height:${({ props }) => (props?.isAnniversary ? "auto" : "10vh")}
    margin-bottom:10%;
    width: 90%;
    height: auto;
    max-width: 90%;
    margin:  margin:${(props) => (props.nodata ? "20% auto" : "0 auto 10px")};
    p{
        height: auto;
    }
}
@media screen and (min-width: 600px) and (max-width: 850px){
    width: 90%;
    height: auto;
    max-width:90%;
    margin:0 auto;
}
::-webkit-scrollbar {
    width: 3.5px;
    border-radius: 9px;
}   
::-webkit-scrollbar-track {
    background-color: #FFF;
    width: 5px;
    border-radius: 9px;
}   
::-webkit-scrollbar-thumb {
    background-color: #C1C1C1;
    border-radius: 9px;
    width: 5px;
}  
{
  -ms-overflow-style: none;
  scrollbar-width: thin;
}
`;

// Title style for SRS popups
export const SRSPopupTitle = styled.h2`
  width: 46vw;
  height: auto;
  text-align: left;
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 120%;
  letter-spacing: 0.01em;
  color: #111111;
  overflow-y: clip;
  margin: 20px auto;
  @media screen and (max-width: 850px) {
    width: 100%;
    margin: 20px 15px;
  }
`;

// Date style for feed items
export const FeedDate = styled.p`
  position: relative;
  top: 37vh;
  width: auto;
  height: auto;
  bottom: 13px;
  font-family: "Lato";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 120%;
  color: #474747;
`;

// Date style for connect feed items
export const ConnectFeedDate = styled.span`
  width: 33%;
  color: #535353;
  font-family: Lato;
  font-size: 14px;
  font-weight: 400;
  font-style: normal;
  line-height: 135%;
  letter-spacing: 0.14px;
  @media only screen and (min-width: 1200px) and (max-width: 1400px) {
    font-size: 13px;
    width: 35%;
  }
  ${(props) =>
    props.feed &&
    `
        max-width: 34%;
        @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
        {
            max-width: 14%;
        }
     `}
  @media screen and (max-width: 850px) {
    top: 0vh;
  }
`;

// Selected language style for connect feed items
export const ConnectFeedSelectedLanguage = styled.span`
  width: auto;
  color: #535353;
  font-family: Lato-bold;
  font-size: 14px;
  font-style: normal;
  line-height: 135%;
  letter-spacing: 0.14px;
  position: relative;
  @media screen and (min-width: 1200px) and (max-width: 1400px) {
    font-size: 12px;
    width: 7em;
  }
  & img {
    position: relative;
    top: -0.2vh;
    width: 8px;
    height: 8px;
  }
`;

// Date style for connect tracking items
export const ConnecttrackingDate = styled.span`
  position: relative;
  left: 0vh;
  width: auto;
  color: #535353;
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  line-height: 135%;
  letter-spacing: 0.14px;
  @media screen and (min-width: 1200px) and (max-width: 1400px) {
    font-size: 12px;
  }
`;

// Message status style for connect items
export const ConnectmessageStatus = styled.span`
  max-width: 40%;
  height: auto;
  color: #111111;
  font-family: Lato;
  font-weight: 400;
  font-size: 14px;
  font-style: normal;
  line-height: 135%;
  letter-spacing: 0.14px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  & img {
    position: relative;
    top: -0.2vh;
    width: 8px;
    height: 8px;
  }
  @media screen and (max-width: 850px) {
    top: 0vh;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  @media screen and (min-width: 1200px) and (max-width: 1400px) {
    font-size: 12px;
    max-width: 43%;
  }
  @media screen and (min-width: 1400px) and (max-width: 1600px) {
    font-size: 13px;
    max-width: 43%;
  }
  ${(props) =>
    props.popup &&
    `
        max-width: 50%;
        margin-left: 5%;
        display: -webkit-box;
       -webkit-line-clamp: 2;
       overflow:hidden;
       text-overflow: ellipsis;
      -webkit-box-orient: vertical;
     `}
`;

// Rejection icon style
export const Rejection = styled.img`
  position: relative;
  left: 1%;
  width: 16px;
  height: 16px;
  ${(props) =>
    props.rejectedMessage &&
    `
        top: 12%;
    `}
  @media screen and (max-width: 600px) {
    left: -5%;
    top: 4%;
  }
  @media screen and (min-width: 1400px) {
    top: ${(props) => (props?.rejectedMessage ? "7%" : "3%")};
  }
`;

// Wrapper for SRS items in popups
export const SRSItemsWrapper = styled.div`
  display: flex;
  padding: 5px 10px 20px 5px;
  @media screen and (max-width: 600px) {
    flex-direction: column;
    padding: 0px;
  }
`;

// Wrapper for birthday items in popups
export const BirthdayItemsWrapper = styled.div`
  display: flex;
  padding: 5px 10px 20px 5px;
  justify-content: space-evenly;
  @media screen and (max-width: 600px) {
    flex-direction: column;
    padding: 0px;
    align-items: center;
  }
`;

// Icon style for SRS popups
export const PopupSRSIcon = styled.div`
  text-align: right;
  width: 15%;
  & img {
    max-width: ${(props) => (props?.isBirthday ? "100%" : "90%")};
    max-height: ${(props) => (props?.isBirthday ? "100%" : "90%")};
    padding: 5%;
    border: 3px solid #ffffff;
    @media screen and (max-width: 600px) {
      padding: 0%;
    }
  }
  @media screen and (max-width: 600px) {
    width: 40%;
    margin-left: 25%;
  }
`;

// Text wrapper for SRS popups
export const SRSPopupText = styled.div`
  width: 85%;
  height: auto;
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 17px;
  line-height: 140%;
  letter-spacing: 0.18px;
  color: #111111;
  padding: 0 5%;
  @media screen and (max-width: 600px) {
    padding: 5%;
    width: 100%;
  }
`;

// Wrapper for video popups
export const VideoPopupWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 10px 10px 0 0;
  background: transparent;
  background-size: cover;
  background-position: center;
  overflow: hidden auto;
  padding: 3% 5%;
  margin: 0.5%;
`;

// iFrame style for video popups
export const VideoIframeCard = styled.iframe`
  position: relative;
  width: auto;
  height: auto;
  width: 100%;
  height: ${(props) => (props?.fullH ? "100%" : "45vh")};
  border-radius: 8px;
  background: #000;
  margin: 0;
`;

// Details wrapper for video popups
export const VideoPopupDetails = styled.div`
  position: absolute;
  width: 90%;
  margin: 0 auto;
  height: auto;
  border-radius: 0px 0px 10px 10px;
  padding-left: 0px;
  margin-top: 2%;
  display: ${(props) => (props.fullH ? "none" : "")};
  @media only screen and (min-device-width: 740px) and (max-device-width: 1199px) and (orientation: portrait) {
    top: 45vh;
    width: 90vw;
    margin-left: -15px;
  }
  @media screen and (min-width: 1200px) and (max-width: 1400px) {
     {
      margin-left: -1.6em;
    }
  }
  @media screen and (min-width: 1600px) and (max-width: 1920px) {
     {
      width: 45.59vw;
    }
  }
  @media only screen and (max-width: 740px) {
     {
      width: 100%;
      margin-left: -8px;
    }
  }
`;

// Play button style for video popups
export const VideoPlayButton = styled.button`
   position: absolute;
    width: 25px;
    height: 25px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: url(${playIcon}) 0 0;
    background-repeat: no-repeat;
    z-index: 3;
`;

// Save button style for video popups
export const SaveVideoButton = styled.button`
   {
    position: absolute;
    width: auto;
    height: 3.1vh;
    right: 9vw;
    top: 7vh;
    background-color: transparent;
    & img {
      position: relative;
      width: 2.1vh;
      height: 2.1vh;
      background-color: transparent;
      border: 0;
      bottom: 2px;
      border-radius: 0;
    }
    & span {
      position: relative;
      color: #fff;
      font-size: 18px;
      font-family: Lato;
      font-weight: 500;
      line-height: 120%;
      @media screen and (max-width: 850px) {
        display: none;
      }
    }
    @media screen and (max-width: 850px) {
      right: 14vw;
      padding-left: 3%;
      top: 3.5vh;
    }
  }
`;

// Share button style for video popups
export const ShareVideoButton = styled.button`
    position: absolute;
    width: 5.2vw
    height: 3.1vh;
    left: 51vw;
    top: 7vh;
    background-color: transparent;
    & img{
        position: relative;
        width: 1.3vw;
        height: 2.6vh;
        background-color: transparent;
        border:0;
        bottom:2px;
        border-radius: 0;
        @media screen and (max-width: 850px){
            width:auto;
        }
    }
    & span{
        position: relative;
        color: #FFF;
        font-size: 18px;
        font-family: Lato;
        font-weight: 500;
        line-height: 120%;
        @media screen and (max-width: 850px){
            display:none;
        }
    }
    @media screen and (max-width: 850px){
        left:72vw;
        top: 3.5vh;
    }
`;

// Title style for video popups
export const VideoTitle = styled.div`
  position: relative;
  width: 100%;
  color: #000;
  font-size: 24px;
  font-family: Lato;
  font-weight: 600;
  line-height: 130%;
  letter-spacing: 0.02em;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  :empty {
    margin-bottom: 0;
  }
  @media screen and (max-width: 850px) {
    width: 95%;
    -webkit-line-clamp: 2;
  }
`;

// Icon button style for video popups
export const VideoIconButton = styled.div`
  margin-left: -1%;
`;

// Details style for video popups
export const VideoDetails = styled.div`
  position: relative;
  max-width: ${(props) => (props?.widthfull ? "95%" : "100%")};
  color: #rgba(17, 17, 17, 1);
  font-size: 18px;
  font-family: Lato;
  line-height: 130%;
  text-align: justify;
  padding-right: 5%;
  & p {
    white-space: pre-wrap;
  }
  @media screen and (max-width: 850px) {
    padding-left: 3%;
    max-width: ${(props) => (props?.widthfull ? "95%" : "100%")};
    padding-right: 10px;
  }
  @media screen and (min-width: 1200px) and (max-width: 1400px) {
    max-width: ${(props) => (props?.widthfull ? "95%" : "100%")};
    padding-right: 0px;
  }
`;

export const StyledDescription = styled.p`
  word-wrap: break-word; 
  @media (min-width: 1200px) and (max-width: 1400px) {
    margin-left: 1.5rem;
    width: 105%;
  }
`;

// Date style for video popups
export const VideoDate = styled(VideoDetails)`
  position: relative !important;
  color: #b7b3b3;
  font-weight: 400;
  line-height: 135%;
  letter-spacing: 0.14px;
  height: auto;
   padding-bottom: 1rem;
  color: #f66700;
  font-weight: bold;
  padding: 5px 0;
`;

// Video player style
export const VideoPlayer = styled.video`
    position: relative;
    width: 100%;
    height: ${(props) => (props?.fullH ? "100%" : "45vh")};
    border-radius: ${(props) => (props?.fullH ? "10px" : "10px 10px 0px 0px")}};
    display: block;
    margin: auto;
`;

// Background wrapper for new child popups
export const NewChildPopupBG = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 11;
  display: ${({ show }) => (show ? "block" : "none")};
  height: 100%;
  width: 100vw;
  display: flex;
  backdrop-filter: invert(40%);
  @media screen and (max-width: 600px) {
    height: ${({ height }) => (height ? height : "100%")};
  }
`;

// Wrapper for new child popups
export const NewChildPopupWrapper = styled.div`
    z-index: ${({ zindex }) => (zindex ? zindex : "12")};
    display: ${({ show }) => (show ? "block" : "none")};
    position: fixed;
    top: 50%;
    left: 50%;
    overflow-y: auto;
    transform: translate(-50%, -50%);
    height: ${({ height }) => (height ? height : "39vh")};
    width: ${({ width }) => (width ? width : "36vw")};
    background: #FFFFFF;
    display:flex;
    flex-direction: column;
    border-radius: 10px;
    overflow-X: clip;
    padding: 0 2% 2% 0;
    @media screen and (max-width: 600px){
        {
            max-height: 95% !important;
            height:auto !important;
            width: 90vw !important;
            overflow-y: auto;
            padding: 0 2% 5% 0;
        }
    }
    @media screen and (min-width: 600px) and (max-width: 850px){
        {
            max-height: ${({ maxheight }) =>
              maxheight ? maxheight : "55%"}; !important;
            height:auto !important;
            width: ${({ width }) => (width ? "90%" : "65%")}; !important;
        }
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        & {
            max-height: max-content;
        }
    }
    @media screen and (max-width: 375px){
        {
            width: 100vw !important;
        }
    }
    @media screen and (min-width: 1200px) and (max-width:1400px) {
        {
            height: ${({ height }) => (height ? height : "41vh")};
        }
    } 
`;

// Wrapper for prompt popups
export const PromptPopupWrapper = styled.div`
  z-index: 9;
  display: ${({ show }) => (show ? "block" : "none")};
  position: fixed;
  top: 50%;
  left: 50%;
  overflow-y: auto;
  transform: translate(-50%, -50%);
  height: max-content;
  width: 65%;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  overflow-x: clip;
  padding: 0 2% 2% 0;
  @media screen and (max-width: 600px) {
     {
      max-height: 80% !important;
      height: auto !important;
      width: 90vw !important;
      overflow-y: auto;
      padding: 0 2% 5% 0;
      top: 47%;
    }
  }
  @media screen and (min-width: 600px) and (max-width: 749px) {
     {
      height: auto !important;
      width: 90% !important;
    }
  }
  @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) {
    & {
      max-height: max-content;
      width: 90%;
    }
  }
  @media screen and (max-width: 375px) {
     {
      width: 100vw !important;
    }
  }
  @media screen and (min-width: 1200px) and (max-width: 1400px) {
     {
      height: max-content;
    }
  }
`;

// Title style for new child popups
export const NewChildPopupTitle = styled.div`
  position: relative;
  margin-top: 2vh;
  left: 5%;
  color: #000;
  font-family: Lato;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
  overflow-y: clip;
  @media screen and (max-width: 600px) {
    margin-top: 3.5vh;
    max-width: 90%;
  }
`;

// Content wrapper for new child popups
export const NewChildContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  margin: 4.5% 0;
  place-content: center;
`;

// Icon wrapper for new child popups
export const PopupNewChildIcon = styled.div`
  margin: 0 5%;
  & img {
    left: 7%;
    top: ${(props) => (props.privacy ? "14vh" : "10vh")};
    width: 10.3vh;
    height: 10.3vh;
    @media screen and (max-width: 850px) {
      width: auto;
      top: 35%;
    }
  }
`;

// Text wrapper for new child popups
export const NewChildPopupText = styled.div`
  top: ${(props) =>
    props.policy ? "12vh" : props.homePolicy ? "15vh" : "11vh"};
  left: 19vh;
  width: ${(props) => (props.policy ? "60%" : "70%")};
  height: auto;
  color: #111;
  font-family: Lato;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  letter-spacing: 0.18px;
  overflow-x: clip;
  text-overflow: ellipsis;
  text-align: left;
  @media screen and (max-width: 850px) {
    width: 60%;
    top: 36%;
    left: 38%;
  }
  @media screen and (min-width: 820px) and (max-width: 1200px) {
    width: 65%;
    top: 33%;
    left: 35%;
  }
  ${(props) =>
    props.homePolicy &&
    `        
    & a {
        word-wrap: break-word;
    }
    @media screen and (max-width: 850px){
        width: 60%;
        top:  30%;
        left: 35%;
        word-wrap: break-word;
    }
    @media screen and (max-width: 480px){
        width: 66%;
        top: 35%;
        left: 37%;
    }
    @media screen and (max-width: 375px){
        width: 67%;
        top:  32%;
        left: 35%;
    }
 `}
  ${(props) =>
    props.policy &&
    `
@media screen and (max-width: 375px){
    width: auto;
    top:  32%;
    left: 30%;
}
`}
`;

// Yes button style for confirmations
export const YesButton = styled.button`
    display: flex;
    width: 17vh;
    height: 6vh;
    padding: 13px 16px 13px 19px;
    justify-content: center;
    align-items: center;
    gap: 12px;
    top:${({ home }) => (home ? "30vh" : "26vh")};
    left: 50%;
    margin: auto;
    flex-shrink: 0;
    border-radius: 8px;
    border: 1px solid #FF6B00;
    background: #F66700;
    box-shadow: rgb(199, 83, 0) 0px 3px 0px;
    margin-bottom:5px;
    & span{
        position:relative;
        color: #FFF;
        font-family: Lato;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
    }
    @media screen and (max-width: 600px){
        top: ${({ home }) => (home ? "80%" : "65%")};
        
    }
    @media screen and (min-width: 600px) and (max-width: 850px){
        top: ${({ home }) => (home ? "72%" : "65%")};
    }
`;

// No button style for confirmations
export const NoButton = styled.a`
    display: flex;
    justify-content: center;
    align-items: center;
    top:${({ home }) => (home ? "36.5vh" : "32.5vh")};
    left: 50%;
    background: #FFF;
    color: #C75300;
    cursor: pointer;
    margin-top:10px;
    &: hover{
        color: #C75300;
    }
    @media screen and (max-width: 850px){
        top: ${({ home }) => (home ? "90%" : "88%")};
    }
    @media screen and (max-width: 600px){
        top: ${({ home }) => (home ? "93%" : "85%")};
    }
`;

// Not right now button style for confirmations
export const NotRightNow = styled.a`
    display: flex;
    justify-content: center;
    align-items: center;
    color: #C75300;
    margin-top: ${({ birthday }) => (birthday ? "0" : "15px")};
    margin-bottom: ${({ birthday }) => (birthday ? "15px" : "0")};
 }
`;

// No thanks button style for confirmations
export const NoThanks = styled(NotRightNow)`
  position: absolute;
  color: #111111;
  bottom: 3vh;
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 125%;
  cursor: pointer;
  @media screen and (min-width: 1200px) and (max-width: 1400px) {
     {
      bottom: 3vh;
    }
  }
`;

// OK ready button style for confirmations
export const OKReady = styled(NotRightNow).attrs({
  as: "button",
  type: "button",
})`
    position: absolute;
    font-size: 2.6vh;
    color: #000;
    bottom: 4vh;
    cursor: pointer;
    text-decoration: underline;
    background: transparent;
    border: none;
    padding: 0;
    &: hover{
        color: #C75300;
    }
`;

// Confirmation popup wrapper
export const ConfirmationPopupWrapper = styled.div`
  z-index: 11;
  display: ${({ show }) => (show ? "block" : "none")};
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding-bottom: 10px;
  width: 40%;
  background: #ffffff;
  display: block;
  border-radius: 10px;
  @media screen and (max-width: 600px) {
     {
      padding-bottom: 10px;
      width: 60%;
    }
  }
  @media screen and (min-width: 600px) and (max-width: 850px) {
     {
      padding-bottom: 10px;
      width: 35%;
    }
  }
`;

// Confirmation popup text style
export const ConfirmationPopupText = styled.div`
  width: 46vh;
  height: auto;
  color: #111;
  font-family: Lato;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  letter-spacing: 0.18px;
  width: auto;
  text-align: center;
  margin-top: 10%;
  @media screen and (max-width: 850px) {
     {
      margin-top: 15%;
      padding: 0 15px;
    }
  }
`;

// Container for image differences in popups
export const ImageDiffContainer = styled.div`
    display:grid;
    grid-template-columns: ${(props) =>
      props.newImage ? "40%" : "40% 10% 40%"};
    justify-content: center;
    padding-bottom:20px;
    margin-top:3%;
    @media screen and (max-width: 1199px){
        margin-top:5%;
    }
    & .right-icon {
        place-self:center;
        width:20px;
    }
    & aside {
        position:relative;
        & .fallback-div-image {
            position:relative !important;
            text-align: center;
            background-color: #000;
            width: 100%;
        }
    & .fallback-div-image img {
            aspect-ratio: auto;
            width:95%; 
            padding: 1rem;
        }
    & img {
        width:100%;
        aspect-ratio: 1;
        object-fit: contain;
        object-position: top;
        border-radius:6px;
        box-shadow: 2px 3px 3px #00000030; 
        @media screen and (max-width: 1199px){
            aspect-ratio: auto;
        }
    }
}
& div{
    position:relative;
    width:90%;
    margin:0 auto;
    bottom:0;
    border-radius: 0px 0px 5px 5px;
    opacity: 0.9;
    text-align:center;
    color:white;
    font-family: Lato;
    padding:2px 0;
& p{
    margin:0;
    font-size:18px;
    font-weight:500;
    @media screen and (max-width: 750px){
        font-size:14px;
        font-weight:500;
    }
}
& span{
    margin:0;
    font-size:18px;
    font-weight:500;
    @media screen and (max-width: 750px){
        font-size:14px;
        font-weight:500;
    }
}
}
}
`;

// Age text style for anniversary popups
export const AnniversaryPopupAgeText = styled.div`
  background: rgb(0, 0, 0);
  position: absolute !important;
  width: 90%;
  margin: 0 auto;
  left: 5%;
  opacity: 0.75 !important;
`;

// Card style for popups
export const Card = styled.div`
  padding: 20px;
  width: 90%;
  margin: auto;
  text-align: center;
`;

// Header style for birthday cards
export const BirthdayCardHeader = styled.div`
  margin-bottom: 1rem;
  & img {
    width: 15%;
    @media screen and (max-width: 749px) {
      width: 35%;
    }
    @media only screen and (min-width: 1200px) and (max-width: 1400px) {
      width: 13%;
    }
  }
  & p {
    font-size: 20px;
    color: rgba(17, 17, 17, 1);
    font-weight: 400;
    font-style: Lato;
  }
  .grey {
    color: rgba(102, 102, 102, 1);
    font-size: 16px;
  }
  & button {
    font-size: 16px;
    color: rgba(255, 107, 0, 1);
    font-weight: 400;
    font-style: Lato;
    background-color: transparent;
    margin-right: 5px;
    & span {
      margin-left: 0.25rem;
    }
  }
  .circledArrow img {
    margin: -4px 0px 0px 0px;
    width: 18px;
    height: 18px;
    border: 1px solid #ff6b00;
    border-radius: 50px;
    cursor: pointer;
  }
`;

// Content style for birthday cards
export const BirthdayCardContent = styled.div`
  display: grid;
  grid-template-columns: 30% 70%;
  gap: 20px;
  align-items: center;
  @media screen and (max-width: 749px) {
    display: flex;
    flex-flow: column;
    text-align: center;
    justify-content: center;
  }
`;

// Button wrapper style for birthday cards
export const BirthdayCardButtons = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: center;
  gap: 10px;
  @media screen and (max-width: 749px) {
    flex-flow: column;
    gap: 1rem;
  }
`;

// Left side content style for birthday cards
export const LeftSide = styled.div`
  display: flex;
  justify-content: center;
`;

// Right side content style for birthday cards
export const RightSide = styled.div`
  text-align: left;
  @media screen and (max-width: 749px) {
    text-align: center;
  }
`;

// Title text style for birthday cards
export const TitleText = styled.p`
  font-size: 18px;
  color: background: rgba(0, 0, 0, 1);
  font-weight:400;
  margin-bottom: 1rem;
  @media only screen and (min-width:1200px) and (max-width:1400px){
    font-size: 17px;
    margin-bottom: 0.5rem;
  }
`;

// Child image style for birthday cards
export const ChildImage = styled.img`
  width: 80%;
  border-radius: 8px;
`;

// Title style for birthday cards
export const Title = styled.h1`
  font-size: 24px;
  color: rgba(17, 17, 17, 1);
  font-weight: 700;
`;

// Button style for birthday cards
export const Button = styled.button`
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  color: white;
  width: 50%;
  font-size: 20px;
  font-weight: 700;
  font-family: Lato;
  background-color: rgba(255, 107, 0, 1);
  box-shadow: 0px 3px 0px 0px rgba(199, 83, 0, 1);
  letter-spacing: 0.5px;
  @media screen and (max-width: 749px) {
    width: 100%;
  }
`;

// Tracking style for birthday popups
export const BirthdayTracking = styled.div`
  width: 65%;
  margin: 0px auto;
  margin-left: 22%;
  @media screen and (max-width: 749px) {
    width: 100%;
    margin: 0px auto;
  }
  @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) {
    margin: 0px auto;
    margin-right: 22%;
  }
`;